import { ICommonLink } from '@src/models/common';

export const CUSTOMER: ICommonLink = {
  id: 'customerLink',
  href: '/customer',
  name: 'Клиенты',
  disableNextJs: true,
  tags: ['role.account-manager', 'role.admin', 'role.supervisor'],
  icon: 'clients',
};
